import { TrackCellType, type Circuit, type TrackCell } from '../types/track.js';

/**
 * L’ancienne case « joker bonus » (type 4) n’est plus une mécanique de jeu.
 * On la convertit en droite pour ne pas bloquer d’anciens JSON circuit.
 * Ne touche pas à `JOKER_LAP` (type 6) ni à la branche `jokerLap`.
 */
export function normalizeDeprecatedJokerBonusCellType(type: TrackCellType): TrackCellType {
  return type === TrackCellType.JOKER ? TrackCellType.STRAIGHT : type;
}

function normalizeCell(cell: TrackCell): TrackCell {
  const next = normalizeDeprecatedJokerBonusCellType(cell.type);
  return next === cell.type ? cell : { ...cell, type: next };
}

export function normalizeCircuitCellTypes(circuit: Circuit): Circuit {
  const path = circuit.path.map(normalizeCell);
  const grid = circuit.grid.map((row) =>
    row.map((cell) => normalizeDeprecatedJokerBonusCellType(cell))
  );
  let changed =
    path.some((cell, i) => cell !== circuit.path[i]) ||
    grid.some((row, y) => row.some((cell, x) => cell !== circuit.grid[y]?.[x]));

  let jokerLap = circuit.jokerLap;
  if (jokerLap?.cells?.length) {
    const cells = jokerLap.cells.map(normalizeCell);
    if (cells.some((cell, i) => cell !== jokerLap!.cells[i])) {
      jokerLap = { ...jokerLap, cells };
      changed = true;
    }
  }

  let startLane = circuit.startLane;
  if (startLane?.cells?.length) {
    const cells = startLane.cells.map(normalizeCell);
    if (cells.some((cell, i) => cell !== startLane!.cells[i])) {
      startLane = { ...startLane, cells };
      changed = true;
    }
  }

  if (!changed) return circuit;
  return {
    ...circuit,
    path,
    grid,
    ...(jokerLap ? { jokerLap } : {}),
    ...(startLane ? { startLane } : {}),
  };
}
